import * as ScreenSizes from './ScreenSizes';
export const MAIN_SECTION_MAX_WIDTH = 1280;
export const MAIN_SECTION_PADDING_X = 48;
export const MAIN_SECTION_PADDING_Y = 40;
export const SCREEN_SIZE_ORDER = [ScreenSizes.XS, ScreenSizes.SM, ScreenSizes.MD, ScreenSizes.LG, ScreenSizes.XL];